import { Avatar } from "@/components/ui";
import { APP_DATE_FORMAT_EXPANDED } from "@/config/constants";
import { IEdoChatMessage } from "@/shared/model/edo-chat-message.model";
import { TextFormat } from "react-jhipster";

export interface OtherMessageProps {
  messaggio: IEdoChatMessage;
}

export const OtherMessage = (props: OtherMessageProps) => {
  const { messaggio } = props;

  return (
    <div className="flex items-start gap-3">
      <Avatar className="h-10 w-10 shrink-0">
        {messaggio.user.firstName[0] + messaggio.user.lastName[0]}
      </Avatar>
      <div className="flex min-w-0 flex-1 flex-col">
        <p className="text-sm font-medium text-[var(--color-mockup-text)]">
          {messaggio.user.firstName} {messaggio.user.lastName}
        </p>
        <p className="text-sm text-[var(--color-mockup-text)]">{messaggio.message}</p>
        <span className="text-xs text-[var(--color-mockup-text-light)]">
          <TextFormat
            type="date"
            value={messaggio.createdAt}
            format={APP_DATE_FORMAT_EXPANDED}
            locale="it"
          />
        </span>
      </div>
    </div>
  );
};
